import React from "react";
import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  InMemoryCache,
} from "@apollo/client";
import { Provider } from "react-redux";
import Store from "./setup/redux/Store";
import { AppRoutes } from "./routing/AppRouting";
import { onError } from "@apollo/client/link/error";
import { relayStylePagination } from "@apollo/client/utilities";
import { setContext } from "@apollo/client/link/context";
import AuthService from "./components/modules/auth/redux/AuthService";
import { API_URL } from "./setup/helper/apiUrl";
import { LoadingProvider, useLoading } from "./contexts/LoadingContext";
import LoadingModal from "./components/LoadingModal";

const AppWithLoading = () => {
  const { isLoading, loadingMessage } = useLoading();
  
  return (
    <>
      <AppRoutes />
      <LoadingModal visible={isLoading} message={loadingMessage} />
    </>
  );
};

const App = () => {
  const url = API_URL
  var hours = 3; // to clear the localStorage after 1 hour
  // (if someone want to clear after 8hrs simply change hours=8)
  var now = new Date().getTime();
  var setupTime = localStorage.getItem("setupTime");
  if (setupTime == null) {
    localStorage.setItem("setupTime", now);
  } else {
    if (now - setupTime > hours * 60 * 60 * 1000) {
      localStorage.clear();
      localStorage.setItem("setupTime", now);
    }
  }
  // recommendations -> don't pass function as props
  //                    as possible as do not use callback functions 
  const user =
    AuthService.GetCurrentUser() != null ? AuthService.GetCurrentUser() : null;

  const httpLink = createHttpLink({
    uri: API_URL +"/graphql/",
  });

  const authLink = setContext((_, { headers }) => {
    const token = user != null ? user.token : "";

    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : "",
      },
    };
  });

  const cache = new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          activityTypes: relayStylePagination(),
        },
      },
    },
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      //strinify
      graphQLErrors.forEach(({ message, path }) => {
        if (/not authorized/.test(message)) Store.dispatch(logout());
      });
    }
  });

  const client = new ApolloClient({
    link: errorLink.concat(authLink.concat(httpLink)),
    cache,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "no-cache",
        errorPolicy: "ignore",
      },
      query: {
        fetchPolicy: "no-cache",
        errorPolicy: "all",
      },
    },
  });
  return (
    <Provider store={Store}>
      <ApolloProvider client={client}>
        <LoadingProvider>
          <AppWithLoading />
        </LoadingProvider>
      </ApolloProvider>
    </Provider>
  );
};

export { App };
